import script from "./Vistoria.vue?vue&type=script&setup=true&lang=js"
export * from "./Vistoria.vue?vue&type=script&setup=true&lang=js"

import "./Vistoria.vue?vue&type=style&index=0&id=90b20c7e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90b20c7e"]])

export default __exports__